module.exports = __webpack_public_path__ + "img/app-store.b20e8619.png";